import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

const { REQUIRED } = ERROR_TYPE;

export const CompanySizeSchema = z.object({
	id: z.number().optional(),
	value: z.string().min(1, { message: REQUIRED }),
});

export const CreateCompanySizeSchema = z.object({
	value: z.string().min(1, { message: REQUIRED }),
});

export const UpdateCompanySizeSchema = z.object({
	id: z.number(),
	value: z.string().min(1, { message: REQUIRED }),
});

export const DeleteCompanySizeSchema = z.object({
	id: z.number(),
});

export const CompanySizeArraySchema = z.array(CompanySizeSchema);

export type CompanySize = z.infer<typeof CompanySizeSchema>;
export type CreateCompanySize = z.infer<typeof CreateCompanySizeSchema>;
export type UpdateCompanySize = z.infer<typeof UpdateCompanySizeSchema>;
export type DeleteCompanySize = z.infer<typeof DeleteCompanySizeSchema>;
export type CompanySizeArray = z.infer<typeof CompanySizeArraySchema>;
